import { useState } from "react";
import PostCard from "./postCards";
import classes from "./techPovLayout.module.css";
import posts from "../Hero/heroPosts/postData"; // Import your posts data
import SideBar from "./sidebarTech/sidebar";


const TechPovLayout = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 5;
const parseDate = (dateStr) => new Date(dateStr.replace("Posted on ", ""));


    // Calculate total pages
    const totalPages = Math.ceil(posts.length / postsPerPage);

    const recentPosts = posts
      .sort((a, b) => parseDate(b.date) - parseDate(a.date))

    // Change page
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        // Scroll to top when page changes
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={classes.MainContainerTech}>
        <div className={classes.techPovLayout}>
            <div className={classes.techPovContent}>
                {recentPosts.map((post) => (
                    <PostCard 
                        key={post.id}
                        techImage={post.imageUrl} 
                        techOwner="Vivek Sharma" 
                        techDate={post.date} 
                        headingTech={post.title} 
                        descriptionTech={post.detailedDescription}
                    />
                ))}
                
                {/* Pagination */}
                {totalPages > 1 && (
                    <div className={classes.pagination}>
                        <button 
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className={classes.paginationBtn}
                        >
                          Prev
                        </button>
                        
                        {[...Array(totalPages)].map((_, index) => (
                            <button
                                key={index + 1}
                                onClick={() => handlePageChange(index + 1)}
                                className={`${classes.paginationBtn} ${
                                    currentPage === index + 1 ? classes.active : ''
                                }`}
                            >
                                {index + 1}
                            </button>
                        ))}
                        
                        <button 
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className={classes.paginationBtn}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
            <div className={classes.techPovSideContainer}>
           <SideBar/>
            </div>
        </div>
        </div>
    )
}

export default TechPovLayout;